var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PrehistoricArtifactSelection.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-04702bc2\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PrehistoricArtifactSelection.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/PrehistoricArtifactSelection.vue
// module id = 809
// module chunks = 1